import { Menu, MenuItem, MenuToggleButton } from "@growtherapy/sprout-ui";
import { useTranslate } from "@growtherapy/i18n";
import { faEllipsis } from "@fortawesome/pro-solid-svg-icons";
import { ComponentProps, ReactElement } from "react";
import { ControlPanelButton } from "./ControlPanelButton";
import { MENU_Z_INDEX_CLASSNAME } from "./constants";

export type MenuChild = ReactElement<ComponentProps<typeof MenuItem>>;

export type AdditionalOptionsMenuProps = {
  shouldShowVisualIndicator: boolean;
  children?: ComponentProps<typeof Menu>["children"];
};

export function AdditionalOptionsMenu({
  children = [],
  shouldShowVisualIndicator,
}: AdditionalOptionsMenuProps) {
  const t = useTranslate();
  return (
    <Menu
      menuClassName={MENU_Z_INDEX_CLASSNAME}
      placement="top"
      toggleButton={
        <MenuToggleButton<typeof ControlPanelButton>
          as={ControlPanelButton}
          visibleCaret={false}
          showVisualIndicator={shouldShowVisualIndicator}
          aria-label={t("telehealth-core:controls.viewAdditionalOptions")}
          iconDefinition={faEllipsis}
          containerClassName="md:hidden"
          shouldOverrideClassName
        />
      }
    >
      {children}
    </Menu>
  );
}
